import Row from './row.element.js';

export default Row;

Row.define('wje-row', Row);
